import script from "./CategorySetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategorySetting.vue?vue&type=script&setup=true&lang=ts"

import "./CategorySetting.vue?vue&type=style&index=0&id=4d89eb87&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d89eb87"]])

export default __exports__